export const categories = [
  {
    id: 1,
    slug: 'guoman',
    name: '国漫',
    icon: 'ri-book-open-line',
    description: '精选优质国产漫画，支持原创作者',
    subcategories: ['热血', '玄幻', '都市', '古风', '搞笑', '悬疑'],
    color: 'accent',
  },
  {
    id: 2,
    slug: 'riman',
    name: '日漫',
    icon: 'ri-sun-line',
    description: '经典日漫一网打尽，正版授权',
    subcategories: ['少年', '少女', '青年', '耽美', '科幻', '校园'],
    color: 'primary',
  },
  {
    id: 3,
    slug: 'hanman',
    name: '韩漫',
    icon: 'ri-flag-line',
    description: '韩漫热门连载，高清全彩条漫',
    subcategories: ['恋爱', '奇幻', '剧情', 'BL', 'GL', '恐怖'],
    color: 'secondary',
  },
  {
    id: 4,
    slug: 'hot',
    name: '热门推荐',
    icon: 'ri-fire-line',
    description: '编辑精选热门漫画，大家都在看',
    subcategories: [],
    color: 'accent',
  },
  {
    id: 5,
    slug: 'latest',
    name: '最新更新',
    icon: 'ri-timer-line',
    description: '刚刚更新的漫画章节，追更不迷路',
    subcategories: [],
    color: 'primary',
  },
  {
    id: 6,
    slug: 'finished',
    name: '已完结',
    icon: 'ri-check-double-line',
    description: '完结漫画一次看个够',
    subcategories: [],
    color: 'secondary',
  },
];

export const comics = [
  {
    id: 1,
    title: '星辰变',
    author: '我吃西红柿',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20a%20young%20male%20cultivator%20with%20long%20black%20hair%20in%20flowing%20white%20robes%2C%20holding%20a%20glowing%20sword%20under%20starry%20night%20sky%2C%20xianxia%20theme%2C%20epic%20composition%2C%20clean%20white%20background%2C%20manga%20cover%20art&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '一颗流星降世，引发修真界大变。少年秦羽天赋异禀，踏上修真之路，历经磨难，成就星辰之力。这是关于成长、热血与守护的史诗故事。',
    category: 'guoman',
    subcategory: '玄幻',
    rating: 9.6,
    views: 12580000,
    status: '连载中',
    tags: ['玄幻', '修真', '热血', '逆袭'],
    updatedAt: '2026-08-08',
    chapters: 486,
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: '斗破苍穹',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20young%20man%20with%20determined%20expression%2C%20flame%20surrounding%20his%20body%2C%20holding%20a%20heavy%20ruler%20weapon%2C%20martial%20arts%20theme%2C%20dramatic%20lighting%2C%20clean%20light%20background%2C%20manga%20cover&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后，突然陨落。在绝望中，他从纳戒中获得神秘力量，踏上复仇与重回巅峰之路。',
    category: 'guoman',
    subcategory: '玄幻',
    rating: 9.5,
    views: 18900000,
    status: '连载中',
    tags: ['玄幻', '热血', '复仇', '斗气'],
    updatedAt: '2026-08-07',
    chapters: 612,
    featured: true,
    hot: true,
  },
  {
    id: 3,
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20supernatural%20manhua%20style%2C%20a%20young%20man%20with%20mysterious%20aura%2C%20glowing%20energy%20around%20hands%2C%20urban%20fantasy%20theme%2C%20traditional%20elements%20mixed%20with%20modern%20setting%2C%20clean%20composition%2C%20cover%20art&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '平凡大学生张楚岚因爷爷的遗体被盗而卷入异人世界，认识了神秘少女冯宝宝。为了解开爷爷身上的秘密，张楚岚加入了"哪都通"公司。',
    category: 'guoman',
    subcategory: '都市',
    rating: 9.7,
    views: 10200000,
    status: '连载中',
    tags: ['都市', '异能', '悬疑', '热血'],
    updatedAt: '2026-08-06',
    chapters: 398,
    featured: false,
    hot: true,
  },
  {
    id: 4,
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20manhua%20style%2C%20beautiful%20fox%20spirit%20girl%20with%20long%20silver%20hair%20and%20red%20traditional%20dress%2C%20cherry%20blossom%20petals%2C%20dreamy%20atmosphere%2C%20ancient%20Chinese%20aesthetic%2C%20clean%20light%20background%2C%20manga%20cover&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '世上有人有妖，妖会与人相恋。妖寿命千万年，人的寿命有限。痴情的妖啊，请在相思树下，等待与所爱之人的来世重逢。',
    category: 'guoman',
    subcategory: '古风',
    rating: 9.4,
    views: 8900000,
    status: '已完结',
    tags: ['古风', '爱情', '奇幻', '催泪'],
    updatedAt: '2026-07-15',
    chapters: 356,
    featured: true,
    hot: false,
  },
  {
    id: 5,
    title: '咒术回战',
    author: '芥见下下',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20teenage%20boy%20with%20spiky%20pink%20hair%2C%20dark%20school%20uniform%2C%20supernatural%20energy%20surrounding%20him%2C%20action%20pose%2C%20dark%20fantasy%20theme%2C%20clean%20white%20background%2C%20shonen%20manga%20cover&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '高中生虎杖悠仁吞下诅咒之王两面宿傩的手指后，被卷入咒术师与诅咒的战斗世界。在东京都立咒术高等专门学校，他踏上成为最强咒术师的道路。',
    category: 'riman',
    subcategory: '少年',
    rating: 9.3,
    views: 15200000,
    status: '连载中',
    tags: ['热血', '战斗', '校园', '超自然'],
    updatedAt: '2026-08-08',
    chapters: 271,
    featured: true,
    hot: true,
  },
  {
    id: 6,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20art%2C%20young%20boy%20with%20scar%20on%20forehead%20wearing%20green%20checkered%20haori%2C%20holding%20a%20katana%2C%20determined%20expression%2C%20water%20breathing%20style%20visual%20effect%2C%20Taisho%20era%20setting%2C%20clean%20background%2C%20manga%20cover&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '大正时代，少年灶门炭治郎全家被鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复为人类的方法，炭治郎踏上了斩鬼之旅。',
    category: 'riman',
    subcategory: '少年',
    rating: 9.8,
    views: 22100000,
    status: '已完结',
    tags: ['热血', '战斗', '亲情', '历史'],
    updatedAt: '2026-06-20',
    chapters: 205,
    featured: false,
    hot: true,
  },
  {
    id: 7,
    title: '间谍过家家',
    author: '远藤达哉',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%2C%20a%20family%20of%20three%20with%20father%20in%20suit%2C%20mother%20with%20red%20hair%2C%20and%20cute%20little%20girl%20with%20pink%20hair%2C%20comedic%20spy%20theme%2C%20warm%20family%20atmosphere%2C%20clean%20light%20background%2C%20manga%20cover%20art&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '为了执行机密任务，西国最强间谍"黄昏"组建临时家庭。但他不知道，妻子是杀手，女儿是超能力者。三人互相隐瞒身份，共同生活。',
    category: 'riman',
    subcategory: '校园',
    rating: 9.5,
    views: 13500000,
    status: '连载中',
    tags: ['喜剧', '家庭', '间谍', '温馨'],
    updatedAt: '2026-08-06',
    chapters: 98,
    featured: true,
    hot: true,
  },
  {
    id: 8,
    title: '排球少年',
    author: '古馆春一',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20sports%20manga%20style%2C%20orange%20haired%20short%20boy%20jumping%20high%20to%20spike%20volleyball%2C%20dynamic%20action%20pose%2C%20gymnasium%20background%20blur%2C%20energetic%20atmosphere%2C%20clean%20composition%2C%20manga%20cover&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '日向翔阳在初中时被排球部"小巨人"的身影所吸引，立志进入乌野高中排球部。虽然身高不足，但他凭借惊人的跳跃力，与天才二传手影山飞雄组成最强搭档。',
    category: 'riman',
    subcategory: '少年',
    rating: 9.7,
    views: 9800000,
    status: '已完结',
    tags: ['运动', '热血', '青春', '友情'],
    updatedAt: '2026-05-10',
    chapters: 402,
    featured: false,
    hot: false,
  },
  {
    id: 9,
    title: '我独自升级',
    author: 'Chugong',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%2C%20a%20handsome%20young%20man%20with%20dark%20hair%2C%20glowing%20purple%20eyes%2C%20wearing%20black%20combat%20outfit%2C%20shadow%20soldiers%20behind%20him%2C%20dark%20fantasy%20theme%2C%20clean%20background%2C%20manhwa%20cover&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '被称为"人类最弱兵器"的E级猎人成振宇，在一次几乎致命的双重 dungeon 中获得了神秘系统。从此，他成为唯一能够"升级"的猎人，踏上从最弱到最强的逆袭之路。',
    category: 'hanman',
    subcategory: '奇幻',
    rating: 9.6,
    views: 16700000,
    status: '连载中',
    tags: ['奇幻', '逆袭', '战斗', '系统'],
    updatedAt: '2026-08-08',
    chapters: 179,
    featured: true,
    hot: true,
  },
  {
    id: 10,
    title: '全知读者视角',
    author: 'sing N song',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%2C%20an%20ordinary%20office%20worker%20young%20man%20suddenly%20in%20an%20apocalyptic%20world%2C%20holding%20a%20glowing%20book%2C%20surrounded%20by%20monsters%2C%20tense%20atmosphere%2C%20clean%20composition%2C%20manhwa%20cover&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '平凡上班族金独子是唯一读完连载十年网络小说《在灭亡的世界中生存的三种方法》的人。当小说中的世界变成现实，他将凭借对剧情的了解，在这个末日世界中生存下去。',
    category: 'hanman',
    subcategory: '剧情',
    rating: 9.4,
    views: 11200000,
    status: '连载中',
    tags: ['剧情', '末世', '悬疑', '系统'],
    updatedAt: '2026-08-07',
    chapters: 210,
    featured: false,
    hot: true,
  },
  {
    id: 11,
    title: '女神降临',
    author: '喵喵',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20style%2C%20beautiful%20young%20woman%20with%20perfect%20makeup%2C%20long%20brown%20wavy%20hair%2C%20fashionable%20outfit%2C%20school%20setting%2C%20romantic%20comedy%20vibe%2C%20clean%20light%20background%2C%20manhwa%20cover&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '因为外貌被霸凌的女生林周京，通过化妆技术变成了校园女神。她在素颜和化妆的两种人生之间周旋，遇到了两个知道她秘密的男生。',
    category: 'hanman',
    subcategory: '恋爱',
    rating: 9.0,
    views: 9500000,
    status: '已完结',
    tags: ['恋爱', '校园', '喜剧', '成长'],
    updatedAt: '2026-04-30',
    chapters: 223,
    featured: false,
    hot: false,
  },
  {
    id: 12,
    title: '镖人',
    author: '许先哲',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20manhua%20style%2C%20a%20rugged%20swordsman%20in%20ancient%20Chinese%20warrior%20clothing%2C%20riding%20a%20horse%20in%20desert%2C%20holding%20a%20sword%2C%20dusty%20western%20region%20setting%2C%20gritty%20ink%20wash%20style%2C%20cover%20art&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '大业三年，隋王朝在隋炀帝杨广的残暴统治下民不聊生。身手不凡的镖客刀马行走于西域大漠，在逃避朝廷追杀的途中，他遇到了一个改变命运的人。',
    category: 'guoman',
    subcategory: '古风',
    rating: 9.8,
    views: 7200000,
    status: '连载中',
    tags: ['古风', '武侠', '历史', '硬派'],
    updatedAt: '2026-08-05',
    chapters: 142,
    featured: true,
    hot: false,
  },
];